import { Box, CircularProgress, Divider, Typography } from '@mui/material';
import ModalHelpClub from '~/modals/ModalHelpClub';
import { priceFormatter } from '~/utils/priceFormatter';
import { FinancialData } from '../../interfaces/financial-data';
import { purpleText } from '../../styles';

interface Props {
  isLoading: boolean;
  financialData: FinancialData | undefined;
}

export function Resume({ isLoading, financialData }: Props) {
  const { type_club, plan_club_name, plan_has_club, plan_club_description, flat_rate } = financialData || {};

  const clubAmount = Number(flat_rate ?? 0);
  const showClubLine = Boolean(plan_has_club && !Number.isNaN(clubAmount) && clubAmount > 0);
  const isClubType2 = type_club === 2;

  const subscriptionBreakdown = (
    <>
      {showClubLine && (
        <>
          <Box display="flex" alignItems="center" justifyContent="space-between" width="60%" gap={1}>
            <Box display="flex" alignItems="center" gap={0.5}>
              <Typography variant="subtitle2">{plan_club_name}</Typography>
              {plan_club_description && <ModalHelpClub clubDiscription={plan_club_description} />}
            </Box>
            <Typography variant="subtitle2">
              {isLoading ? <CircularProgress size={16} /> : `R$${priceFormatter(clubAmount)}`}
            </Typography>
          </Box>

          <Divider sx={{ width: '70%', margin: '.25rem' }} />
        </>
      )}

      <Box display="flex" alignItems="center" justifyContent="space-between" width="60%">
        <Typography variant="subtitle2">Encargos financeiros</Typography>
        <Typography variant="subtitle2">
          {isLoading ? <CircularProgress size={16} /> : `R$${priceFormatter(financialData?.financial_charges ?? 0)}`}
        </Typography>
      </Box>

      <Divider sx={{ width: '70%', margin: '.25rem' }} />

      <Box display="flex" alignItems="center" justifyContent="space-between" width="60%">
        <Typography
          variant="subtitle2"
          sx={{
            fontWeight: 700,
            fontSize: '1.15rem'
          }}
        >
          Valor total (12x)
        </Typography>
        <Typography
          variant="subtitle2"
          sx={{
            ...purpleText,
            fontSize: '1.15rem'
          }}
        >
          {isLoading ? <CircularProgress size={20} /> : `R$${priceFormatter(financialData?.total ?? 0)}`}
        </Typography>
      </Box>

      <Typography
        variant="subtitle2"
        sx={{
          fontSize: '.8rem',
          fontWeight: '400',
          textAlign: 'center'
        }}
      >
        (Valor a ser pago mensalmente no cartão de crédito)
      </Typography>
    </>
  );

  return (
    <Box
      sx={{
        display: 'grid',
        width: '100%',
        placeItems: 'center'
      }}
    >
      <Typography
        variant="h4"
        align="center"
        sx={{
          ...purpleText,
          fontSize: '1.5rem',
          margin: 1
        }}
      >
        Resumo da assinatura
      </Typography>

      {isClubType2 && !showClubLine ? (
        <>
          <Box display="flex" alignItems="center" justifyContent="space-between" width="60%">
            <Typography
              variant="subtitle2"
              sx={{
                fontWeight: 700,
                fontSize: '1.15rem'
              }}
            >
              Plano anual {plan_club_name}
            </Typography>
            <Typography
              variant="subtitle2"
              sx={{
                ...purpleText,
                fontSize: '1.15rem'
              }}
            >
              {isLoading ? <CircularProgress size={20} /> : `12x R$${priceFormatter(financialData?.total ?? 0)}`}
            </Typography>
          </Box>

          <Typography
            variant="subtitle2"
            sx={{
              fontSize: '.8rem',
              fontWeight: '400',
              textAlign: 'center'
            }}
          >
            (Valor a ser pago mensalmente no cartão de crédito)
          </Typography>
        </>
      ) : (
        subscriptionBreakdown
      )}
    </Box>
  );
}
